import { MultiStepGoalWidget } from "@/Components/MultiStepGoalWidget/MultiStepGoalWidget";
import { SimpleDonoGoalWidget } from "@/Components/SimpleDonoGoalWidget/SimpleDonoGoalWidget";
import { useSocket } from "@/hooks/useSocket";
import { NewGoalUpdateEvent, AnyGoalDoc } from "@ailenax-overlay/shared";
import { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export const OBSGoalWidget: FC = () => {
    const { id } = useParams();
    const socket = useSocket();
    const [goal, setGoal] = useState<AnyGoalDoc | null>(null);

    useEffect(() => {
        socket.emit("get-new-goals", gs => {
            const found = gs.find(bar => bar._id === id);
            if (found) {
                setGoal(found);
            }
        });

        const onNewGoalUpdate = (e: NewGoalUpdateEvent) => {
            if (e.goal._id === id) {
                setGoal(e.goal);
            }
        };

        socket.on("new-goal-update", onNewGoalUpdate);

        return () => {
            socket.off("new-goal-update", onNewGoalUpdate);
        };
    }, [id, socket]);

    if (!goal) {
        return null;
    }

    if (goal.goalType === "simple") {
        return <SimpleDonoGoalWidget goal={goal} />;
    }

    return <MultiStepGoalWidget goal={goal} />;
};
